import React from "react";
import "react-tabs/style/react-tabs.css";
import { CardBody,Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Form, Button, Card, Col, Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import {Helmet} from "react-helmet";
import dateFormat from 'dateformat';
import { toast } from 'react-toastify';

class TankFlowView extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
	  tankId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      modal: false,
      tankData: [],
      iotHistoryData: [],
      flowmeterdata: [],
      iotlevelData: [],
      test: [],
	  deviceId: "",
	  capacity: "",
	  type: "",
	  shape: "",
	  height: "",
	  length: "",
	  width: "",
	  flowView:  false,
	  flowViewModal:  false,
    };
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {
	  
	let postUserData = {
		tankId: this.state.tankId
	};
  
	fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/getflowmeterdetails', {
	method: 'POST',
	headers: {
	  'Content-Type': 'application/json',
	  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
	},
		body: JSON.stringify(postUserData)
	}).then((response) => {
		if (response.status === 400) {
		  this.setState({ throwUserError: true })
		} else { return response.json() }
	}).then((data) => {
		this.setState({ flowmeterdata: data.flowmeterdata, userId: data.flowmeterdata[0].userId, FlowmeterId: data.flowmeterdata[0].FlowmeterId })
	}).catch((error) => console.log(error))
		
  }
  
	viewflowmeterdata = (value) =>  {
		this.setState({ 
			flowView: true,
			Popid: value.id,
			PopCustomerID: value.userId,
			PopDeliveryStartAt: value.StartDateTime,
			PopDeliveryEndAt: value.EndDateTime,
			PopStartTotalizer: value.StartTotalizer,
			PopEndTotalizer: value.EndTotalizer,
			PopTotalKL: value.totalKL,
			Popcomments: value.comments,
		})
	}
	
	viewflowmeterdataEdit = (value) =>  {
		this.setState({ 
			flowViewEdit: true,
			Popid: value.id,
			PopCustomerID: value.userId,
			PopDeliveryStartAt: value.StartDateTime,
			PopDeliveryEndAt: value.EndDateTime,
			PopStartTotalizer: value.StartTotalizer,
			PopEndTotalizer: value.EndTotalizer,
			PopTotalKL: value.totalKL,
			Popcomments: value.comments,
		})
	}
	
	
  
	popUpCancel1 = () => {
	  this.setState({ flowView: false })
	}
	
	popUpSave = () => {
		
		let postUserData = {
			id: this.state.Popid,
			comments: this.state.Popcomments,
		};
	  
		fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/updatecomments', {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		},
			body: JSON.stringify(postUserData)
		}).then((response) => {
				this.setState({ 
					flowView: false,
					Popid: "",
					PopCustomerID: "",
					PopDeliveryStartAt: "",
					PopDeliveryEndAt: "",
					PopStartTotalizer: "",
					PopEndTotalizer: "",
					PopTotalKL: "",
					Popcomments: "",
				})
			
				let postUserData = {
					tankId: this.state.tankId
				};
			  
				fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/getflowmeterdetails', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				},
					body: JSON.stringify(postUserData)
				}).then((response) => {
					if (response.status === 400) {
					  this.setState({ throwUserError: true })
					} else { return response.json() }
				}).then((data) => {
					this.setState({ flowmeterdata: data.flowmeterdata })
				}).catch((error) => console.log(error))
			
					toast.success("Updated successfully!!!", {
					  position: toast.POSITION.TOP_CENTER,
					  autoClose: 3000
					});
				})
			}
	
	handleTextarea = (event) => { 
		this.setState({ Popcomments : event.target.value })
	}
	
	popUpCancel1Edit = () => {
	  this.setState({ flowViewEdit: false })
	}
	
	popUpSaveEdit = () => {

	let postUserData = {
		id: this.state.Popid,
		StartDateTime: this.state.PopDeliveryStartAt,		
		EndDateTime: this.state.PopDeliveryEndAt,
		StartTotalizer: this.state.PopStartTotalizer,
		EndTotalizer: this.state.PopEndTotalizer,
		totalKL: this.state.PopTotalKL,
	};

	fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/updateFlowmeterdata', {
	method: 'POST',
	headers: {
	  'Content-Type': 'application/json',
	  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
	},
		body: JSON.stringify(postUserData)
	}).then((response) => {
			this.setState({ 
				flowViewEdit: false,
				Popid: "",
				PopCustomerID: "",
				PopDeliveryStartAt: "",
				PopDeliveryEndAt: "",
				PopStartTotalizer: "",
				PopEndTotalizer: "",
				PopTotalKL: "",
				Popcomments: "",
			})
		
			let postUserData = {
				tankId: this.state.tankId
			};
		  
			fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/getflowmeterdetails', {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json',
			  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			},
				body: JSON.stringify(postUserData)
			}).then((response) => {
				if (response.status === 400) {
				  this.setState({ throwUserError: true })
				} else { return response.json() }
			}).then((data) => {
				this.setState({ flowmeterdata: data.flowmeterdata })
			}).catch((error) => console.log(error))
		
				toast.success("Updated successfully!!!", {
				  position: toast.POSITION.TOP_CENTER,
				  autoClose: 3000
				});
			})
		}

	handleChange = (e) => {	
		switch (e.target.name) {
			case "PopDeliveryStartAt":
				this.setState({ PopDeliveryStartAt: e.target.value })
				break;
			case "PopDeliveryEndAt":
				this.setState({ PopDeliveryEndAt: e.target.value })
				break;
			case "PopStartTotalizer":
				this.setState({ PopStartTotalizer: e.target.value })
				break;
			case "PopEndTotalizer":
				this.setState({ PopEndTotalizer: e.target.value })
				break;
			case "PopTotalKL":
				this.setState({ PopTotalKL: e.target.value })
				break;
			case "newDeliveryStartAt":
				this.setState({ newDeliveryStartAt: e.target.value })
				break;
			case "newDeliveryEndAt":
				this.setState({ newDeliveryEndAt: e.target.value })
				break;
			case "newStartTotalizer":
				this.setState({ newStartTotalizer: e.target.value })
				break;
			case "newEndTotalizer":
				this.setState({ newEndTotalizer: e.target.value })
				break;
			case "newTotalKL":
				this.setState({ newTotalKL: e.target.value })
				break;
			 default: break;
		}
	}
	
	addNewFlowmeterData = () =>{
		this.setState({ 
			flowViewAddNew: true,
		})
	}
	
	popUpCancel1Add = () =>{
		this.setState({ 
			flowViewAddNew: false,
		})
	}
	
	popUpSaveAdd = () => {

	let postUserData = {
		userId: this.state.userId,
		FlowmeterId: this.state.FlowmeterId,		
		StartDateTime: this.state.newDeliveryStartAt,
		EndDateTime: this.state.newDeliveryEndAt,
		StartTotalizer: this.state.newStartTotalizer,
		EndTotalizer: this.state.newEndTotalizer,
		totalKL: this.state.newTotalKL,
	};

	fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/createFlowmeterdata', {
	method: 'POST',
	headers: {
	  'Content-Type': 'application/json',
	  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
	},
		body: JSON.stringify(postUserData)
	}).then((response) => {
			this.setState({ 
				flowViewAddNew: false,
				newDeliveryStartAt: "",
				newDeliveryEndAt: "",
				newStartTotalizer: "",
				newEndTotalizer: "",
				newTotalKL: "",
			})
		
			let postUserData = {
				tankId: this.state.tankId
			};
		  
			fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/getflowmeterdetails', {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json',
			  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			},
				body: JSON.stringify(postUserData)
			}).then((response) => {
				if (response.status === 400) {
				  this.setState({ throwUserError: true })
				} else { return response.json() }
			}).then((data) => {
				this.setState({ flowmeterdata: data.flowmeterdata })
			}).catch((error) => console.log(error))
		
				toast.success("Created successfully!!!", {
				  position: toast.POSITION.TOP_CENTER,
				  autoClose: 3000
				});
			})
		}

  render() {

    let dataArr = [];
    this.state.flowmeterdata.map((data) => {
		let comments = "";
		// var dateFormat = require('dateformat');
		// const sDate = new Date("03/02/2021")
		// var scDate = dateFormat(sDate.getDate(), "dd-mm-yyyy, h:MM:ss TT");		
		// const eDate = new Date(data.EndDateTime)
		// var ecDate = dateFormat(eDate.getDate(), "dd-mm-yyyy, h:MM:ss TT");
		
		if(data.comments){
			if(data.comments.length > 49){
				comments = data.comments.substring(0,50)+'...'
			}else{
				comments = data.comments
			}
		}
      let mdData = [
        // data.id, data.FlowmeterId, scDate, ecDate, data.totalKL, comments, data
        data.id, data.FlowmeterId, data.StartDateTime, data.EndDateTime, data.totalKL, comments, data
      ];
	  // this.setState({ deviceId: data.device_id })
      dataArr.push(mdData)
      return null;
    });
	
	const mystyle = {
	  marginRight: "5px"
    };
	const leveldev = {
	    backgroundColor: "white",
		padding: "10px"
	};
	const leveldevheadercolor = {
	    color: "red"
	};
	
	const wrapper = {
		backgroundColor: "#2d4e5a",
		height: "200px",
		width: "200px",
		position: "relative"
	}

    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "flow_device_id",
        label: "Flow Meter Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "StartDateTime",
        label: "Delivery Start At",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "EndDateTime",
        label: "Delivery End At",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "totalKL",
        label: "Total KL",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "comments",
        label: "Comments",
        options: {
          filter: true,
          sort: true,
		  download: false,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
		  download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
			  <Button variant="outline-success" onClick={() => this.viewflowmeterdata(value)} > Note </Button>
			  <Button variant="outline-success" onClick={() => this.viewflowmeterdataEdit(value)} > Edit </Button>
                {/* &nbsp;&nbsp;&nbsp;<Button variant="outline-danger" onClick={() => this.delete(value)} >
                  Delete </Button>  */}
              </>
            );
          }
        }
      }   
    ];
	
	const columns_client = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "flow_device_id",
        label: "Flow Meter Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "StartDateTime",
        label: "Delivery Start At",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "EndDateTime",
        label: "Delivery End At",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "totalKL",
        label: "Total KL",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "comments",
        label: "Comments",
        options: {
          filter: true,
          sort: true,
		  download: false,
        }
      }  
    ];


    const options = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none", viewColumns: false,
      downloadOptions: {
        filename: 'Flow Meter.csv',
      },
    };

	let flowViewModal = null;
    if (this.state.flowView) {
      flowViewModal = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
			<ModalHeader> Customer ID: {this.state.PopCustomerID}</ModalHeader>
              <ModalBody>
					
				<div className="form-group row">
					<div className="col-lg-4"> 
						<b> Delivery Start At : </b>
					</div>
					<div className="col-lg-8">
						{this.state.PopDeliveryStartAt}
					</div>
				</div>
				
				<div className="form-group row">
					<div className="col-lg-4"> 
					 <b> Delivery End At : </b>
					</div>
					<div className="col-lg-8">
						{this.state.PopDeliveryEndAt}
					</div>
				</div>
				
				<div className="form-group row">
					<div className="col-lg-4"> 
						<b> Start Totalizer : </b>
					</div>
					<div className="col-lg-8">
						{this.state.PopStartTotalizer}
					</div>
				</div>
				
				<div className="form-group row">
					
					<div className="col-lg-4"> 
						<b> End Totalizer : </b>
					</div>
					<div className="col-lg-8">
						{this.state.PopEndTotalizer}
					</div>
				</div>
				<div className="form-group row">
					<div className="col-lg-4"> 
						<b> Total KL : </b>
					</div>
					<div className="col-lg-8">
						{this.state.PopTotalKL}
					</div>
				</div>
				
				<div className="form-group row">
					<div className="col-lg-12">
						<Form.Group controlId="exampleForm.ControlTextarea1">
							<Form.Label>Comments *</Form.Label>
							<Form.Control as="textarea" rows="5" id="note" name="note" value={this.state.Popcomments} onChange={this.handleTextarea}/>
						</Form.Group>
					</div>
				</div>
				
              </ModalBody>
               <ModalFooter>
				<Button variant="outline-danger" onClick={() => this.popUpCancel1()}> Cancel </Button>
				<Button variant="outline-success" onClick={() => this.popUpSave()}> Save </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }
	
    if (this.state.flowViewEdit) {
      flowViewModal = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
			<ModalHeader> Customer ID: {this.state.PopCustomerID}</ModalHeader>
              <ModalBody>
					
				<div className="form-group row">
					<div className="col-lg-5">
						<label>Delivery Start At *</label>
						<input type="text" className="form-control" name="PopDeliveryStartAt" id="PopDeliveryStartAt" placeholder="Delivery Start At" value={this.state.PopDeliveryStartAt} onChange={this.handleChange}/>
					</div>
					<div className="col-lg-5">
						<label>Delivery End At *</label>
						<input type="text" className="form-control" name="PopDeliveryEndAt" id="PopDeliveryEndAt" placeholder="Delivery End At" value={this.state.PopDeliveryEndAt} onChange={this.handleChange}/>
					</div>
				</div>
				
				<div className="form-group row">
					<div className="col-lg-5">
						<label>Start Totalizer *</label>
						<input type="text" className="form-control" name="PopStartTotalizer" id="PopStartTotalizer" placeholder="Start Totalizer" value={this.state.PopStartTotalizer} onChange={this.handleChange}/>
					</div>
					<div className="col-lg-5">
						<label>End Totalizer *</label>
						<input type="text" className="form-control" name="PopEndTotalizer" id="PopEndTotalizer" placeholder="End Totalizer" value={this.state.PopEndTotalizer} onChange={this.handleChange}/>
					</div>
				</div>
				
				<div className="form-group row">
					<div className="col-lg-5">
						<label>Total KL *</label>
						<input type="text" className="form-control" name="PopTotalKL" id="PopTotalKL" placeholder="Total KL" value={this.state.PopTotalKL} onChange={this.handleChange}/>
					</div>
				</div>

              </ModalBody>
               <ModalFooter>
				<Button variant="outline-danger" onClick={() => this.popUpCancel1Edit()}> Cancel </Button>
				<Button variant="outline-success" onClick={() => this.popUpSaveEdit()}> Save </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }
	
	if (this.state.flowViewAddNew) {
      flowViewModal = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalBody>
					
				<div className="form-group row">
					<div className="col-lg-5">
						<label>Delivery Start At *</label>
						<input type="text" className="form-control" name="newDeliveryStartAt" id="newDeliveryStartAt" placeholder="Delivery Start At" value={this.state.newDeliveryStartAt} onChange={this.handleChange}/>
					</div>
					<div className="col-lg-5">
						<label>Delivery End At *</label>
						<input type="text" className="form-control" name="newDeliveryEndAt" id="newDeliveryEndAt" placeholder="Delivery End At" value={this.state.newDeliveryEndAt} onChange={this.handleChange}/>
					</div>
				</div>
				
				<div className="form-group row">
					<div className="col-lg-5">
						<label>Start Totalizer *</label>
						<input type="text" className="form-control" name="newStartTotalizer" id="newStartTotalizer" placeholder="Start Totalizer" value={this.state.newStartTotalizer} onChange={this.handleChange}/>
					</div>
					<div className="col-lg-5">
						<label>End Totalizer *</label>
						<input type="text" className="form-control" name="newEndTotalizer" id="newEndTotalizer" placeholder="End Totalizer" value={this.state.newEndTotalizer} onChange={this.handleChange}/>
					</div>
				</div>
				
				<div className="form-group row">
					<div className="col-lg-5">
						<label>Total KL *</label>
						<input type="text" className="form-control" name="newTotalKL" id="newTotalKL" placeholder="Total KL" value={this.state.newTotalKL} onChange={this.handleChange}/>
					</div>
				</div>

              </ModalBody>
               <ModalFooter>
				<Button variant="outline-danger" onClick={() => this.popUpCancel1Add()}> Cancel </Button>
				<Button variant="outline-success" onClick={() => this.popUpSaveAdd()}> Save </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>View Flow Meter</Breadcrumb.Item>
          </Breadcrumb>
          <div style={{ marginTop: "10px" }}>
            <Button className="float-right"
              variant="outline-success"
              style={{ marginTop: "10px", marginRight: "10px", width: "80px" }}
              onClick={() => this.nextPath("/water-tank/tank-edit",this.state.tankId)
              }>
              Edit
			</Button>
			<Button className="float-right"
              variant="outline-success"
              style={{ marginTop: "10px", marginRight: "10px", width: "80px" }}
              onClick={() => this.addNewFlowmeterData() }>
              Add New
			</Button>
			 {flowViewModal}
            <MUIDataTable
              title={"Flow Meter List"}
              data={dataArr}
              columns={columns}
              options={options} />

          </div>
        </>
      );
    } else {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>View Flow Meter</Breadcrumb.Item>
          </Breadcrumb>
		  
          <div style={{ marginTop: "10px" }}>
			 
            <MUIDataTable
              title={"Flow Meter List"}
              data={dataArr}
              columns={columns_client}
              options={options} />

          </div>
        </>
      );
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(TankFlowView)
